/*
* Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
*/
import {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {globalGroupIdSelector} from '@ion/applications/src/store/selectors/global-group';
import {setTrackingAssetCountLoad} from '../../../../store/actions/tracking';

/**
 * A custom hook for managing the loading state of tracking asset counts.
 *
 * ```typescript
 *
 *  const onLoading = useTrackingAssetCount();
 *
 * ```
 */
export const useTrackingAssetCount = () => {
  const dispatch      = useDispatch();
  const globalGroupId = useSelector(globalGroupIdSelector);

  // Callback function to set the loading state using Redux action.
  const onLoading = useCallback((state) => {
    dispatch(setTrackingAssetCountLoad(state));
  }, []);

  // Set loading state to true on initial render
  useEffect(() => {
    dispatch(setTrackingAssetCountLoad(true));
  }, [globalGroupId]);

  return onLoading;
};

export default useTrackingAssetCount;
